module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-panel', {
    attrs: {
      "contextual-style": "primary"
    }
  }, [_c('h1', {
    staticClass: "panel-title",
    attrs: {
      "slot": "heading"
    },
    slot: "heading"
  }, [_vm._v("\n      " + _vm._s(_vm.$t("account.index.title")) + "\n    ")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("\n            " + _vm._s(_vm.$t("account.index.first_name")) + "\n          ")]), _vm._v(" "), _c('th', [_vm._v("\n            " + _vm._s(_vm.$t("account.index.last_name")) + "\n          ")]), _vm._v(" "), _c('th', [_vm._v("\n            " + _vm._s(_vm.$t("account.index.email")) + "\n          ")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("\n            " + _vm._s(_vm.$store.state.account.firstName) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(_vm.$store.state.account.lastName) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(_vm.$store.state.account.email) + "\n          ")])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_vm._v("\n      Made with love\n    ")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2580c67a"}!./src/app/pages/account/index/index.html
// module id = 1344
// module chunks = 0